import { useEffect, useState } from 'react';
import { navLinks, siteName } from '@/mocks/homeData';

export default function TopBar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const linkCls =
    'flex items-center gap-1.5 whitespace-nowrap text-sm text-foreground-700 transition-colors duration-200 hover:text-primary-600 cursor-pointer';

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled ? 'bg-background-50/95 border-b border-background-200' : 'bg-transparent border-b border-transparent'
      }`}
    >
      <nav className="flex h-16 items-center justify-between px-4 md:px-8">
        <a href="#top" className="flex items-center gap-2 cursor-pointer" aria-label={siteName}>
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-fire-line text-lg" aria-hidden="true"></i>
          </span>
          <span>
            <h1 className="font-heading text-lg font-black leading-none text-foreground-950">{siteName}</h1>
            <span className="mt-0.5 block text-[11px] tracking-wide text-foreground-500">证据留档 · 材料说话</span>
          </span>
        </a>

        <div className="hidden items-center gap-7 md:flex">
          {navLinks.slice(0, 4).map((l) => (
            <a key={l.hash} href={l.hash} className={linkCls}>
              {l.label}
            </a>
          ))}
          <a
            href="#ru-kou"
            className="flex h-9 items-center rounded-md bg-foreground-950 px-4 text-sm text-background-50 whitespace-nowrap transition-colors duration-200 hover:bg-primary-600 cursor-pointer"
          >
            提交线索
          </a>
        </div>

        <button
          type="button"
          aria-label="展开导航"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 md:hidden cursor-pointer"
        >
          <i className={open ? 'ri-close-line text-xl' : 'ri-menu-3-line text-xl'}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <div className="flex flex-col">
            {navLinks.map((l) => (
              <a
                key={l.hash}
                href={l.hash}
                onClick={() => setOpen(false)}
                className="flex h-11 items-center text-sm text-foreground-700 hover:text-primary-600 cursor-pointer"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#ru-kou"
              onClick={() => setOpen(false)}
              className="mt-2 flex h-10 items-center justify-center rounded-md bg-primary-500 text-sm text-background-50 cursor-pointer"
            >
              提交线索
            </a>
          </div>
        </div>
      )}
    </header>
  );
}